import { Container, Flex, Text, Title } from "@mantine/core";
import { useEffect, useEffectEvent } from "react";

import { useSalesContext } from "../../../../sales-context/SalesContext";
import { BrokenComputerIcon } from "../Icons";

export function EnrollFailureScreen({ isProductAsurionBilled }: { isProductAsurionBilled?: boolean }) {
    const { logger, analytics } = useSalesContext();

    const onShowEnrollmentFailure = useEffectEvent(() => {
        logger.warn("hit a snag during enrollment");
        void analytics.dispatcher.dispatchBusinessEvent("EnrollmentSnagDisplayed");
    });

    useEffect(() => {
        onShowEnrollmentFailure();
    }, []);
    return (
        <Flex p="xl" ta="center" direction="column" justify="center" data-testid="sale-finished-view">
            <Container>
                <BrokenComputerIcon />
            </Container>
            <Title
                mt="xxl"
                c="dark.0"
                size="h5"
                fw="var(--mantine-font-weight-heavy)"
                data-testid="sale-view-status-header"
            >
                Hmmm...something went wrong
            </Title>
            <Text c="dark.0" mt="md" size="sm">
                {isProductAsurionBilled
                    ? "We weren\u2019t able to enroll the customer today, but they may be able to try again in the future."
                    : "Don\u2019t worry\u2014we\u2019ll keep trying but there\u2019s a chance it won\u2019t go through."}
            </Text>
        </Flex>
    );
}
